module.exports = {
      id: "astrology-usage",
      viewBox: "0 0 29.4 29.4",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#astrology",
      toString: function () {
        return this.url;
      }
    }